import React from "react";
import { RegisterImportPool } from "./Base";
import * as t from "./types";

const iPool = RegisterImportPool({
    "rdc": import(/* webpackChunkName: "rdc_LinoExposedAPI" */"react-dom/client"),
});

const Lino = window.Lino;

Lino.printToThermal = async function (
    context, options, {noFeedback = false} = {}
) {
    try {
        await window.App.setLoadMask();
        const lc = await import(/* webpackChunkName: "LinoCodex" */"./LinoCodex");
        const rdc = (await iPool.resolve(["rdc"])).rdc;
        const container = document.getElementById('multipurpose-modal-root');
        const modalTitle = document.getElementById('multipurpose-modal-title');
        modalTitle?.style.setProperty('display', 'none');
        const parent = container?.parentElement;
        const root = rdc.createRoot(container)
        const printed: number = await new Promise((resolve) => {
            parent?.style.removeProperty('display');
            root.render(<lc.PrinterProgress totalCount={options.copies}/>);
            window.printer?.executeThermalCopiesPrint(options).then((result) => {
                parent?.style.setProperty('display', 'none');
                modalTitle?.style.removeProperty('display');
                root.unmount();
                if (!result.success) {
                    window.App.toast.show({
                        severity: 'error',
                        summary: `Print Error ${result.printed}/${options.copies}`,
                        detail: result.error || 'Unknown error occurred during printing.',
                    });
                } else {
                    window.App.toast.show({
                        severity: 'success',
                        summary: `Print Success ${result.printed}/${options.copies}`,
                        detail: result.error || 'Printing completed successfully.',
                    });
                }
                resolve(result.printed || 0);
            }).catch((error) => {
                parent?.style.setProperty('display', 'none');
                modalTitle?.style.removeProperty('display');
                root.unmount();
                window.App.toast.show({
                    severity: 'error',
                    summary: `Print Error`,
                    detail: error.message || 'Unknown error occurred during printing.',
                });
                resolve(0);
            });
        });
        if (printed > 0 && !noFeedback
            && options.count_update_action
            && options.count_update_actor
        ) {
            console.log(`Updating printed count to ${printed} via action ${options.count_update_action}`, context);
            await context.actionHandler.runAction({
                action_full_name: options.count_update_action,
                actorId: options.count_update_actor,
                status: {
                    fv: [printed],
                },
            })
        }
    } finally {
        await window.App.unsetLoadMask();
    }
}

Lino.printSVGLabel = async function (context, options) {
    return await (
        Lino.printToThermal as typeof Lino.printToThermal
    )(context, Object.assign(options, { isSVG: true }), { noFeedback: false });
}


Lino.printReceipt = async function (context, options) {
    return await (
        Lino.printToThermal as typeof Lino.printToThermal
    )(context, Object.assign(options, { isSVG: false, height: 0, copies: 1 }), { noFeedback: true });
}
